import { ReactComponent as Icon } from 'assets/menuWide/track.svg'
import React from 'react'

export default function TrackIcon(props: any) {
  return (
    <Icon {...props} />
  )
}